import { useImmerReducer } from 'use-immer'
import reducer, { initialState } from './reducers/index.js'
import Context from './context.js'
import { GestureProvider } from './components/GestureProvider.tsx'

const Provider = ({ children }) => {
  const [state, dispatch] = useImmerReducer(reducer, initialState)

  // these variables will be available via the context
  const value = {
    state,
    dispatch,
  }

  return (
    <Context.Provider value={value}>
      <GestureProvider>{children}</GestureProvider>
    </Context.Provider>
  )
}

export default Provider
